import { FC, ReactNode } from 'react';
import { StoryType } from '@edikk-edikk/country-frontend';
import GirlStub from '#webImages/girl-stub.webp';
import storyCss from '../assets/story-item.module.scss';

type PropsType = {
  story: StoryType;
};

const StoryItemCircle: FC<PropsType> = ({
  story,
}) => {
  const renderSource = (media: string, srcSet: string[]): ReactNode => {
    if (srcSet.length === 0) {
      return null;
    }

    const srcSetAsString = srcSet.join(', ');
    return <source media={media} srcSet={srcSetAsString} />;
  };

  const renderSourceForLargeScreen = (): ReactNode => {
    const urlX1 = story.photoPreviewXsUrl;
    const urlX2 = story.photoPreviewUrl;
    const urlX3 = story.photoUrl;

    if (!urlX1 || !urlX2 || !urlX3) {
      return null;
    }

    const srcSet = [`${urlX1} 1x`, `${urlX2} 2x`, `${urlX3} 3x`];

    return renderSource('(min-width: 800px)', srcSet);
  };

  const renderSourceForSmallScreen = (): ReactNode => {
    const urlX1 = story.photoPreviewXxsUrl;
    const urlX2 = story.photoPreviewXsUrl;
    const urlX3 = story.photoPreviewUrl;

    if (!urlX1 || !urlX2 || !urlX3) {
      return null;
    }

    const srcSet = [`${urlX1} 1x`, `${urlX2} 2x`, `${urlX3} 3x`];

    return renderSource('(max-width: 799px)', srcSet);
  };

  return (
    <div className={storyCss.storyItem__circle}>
      <picture>
        {renderSourceForLargeScreen()}
        {renderSourceForSmallScreen()}
        <img
          className={storyCss.storyItem__image}
          src={story.photoUrl || GirlStub}
          alt={`Story by ${story.advert.name}`}
          loading="lazy"
        />
      </picture>
    </div>
  );
};

export { StoryItemCircle };
